type EventObj = {
	onNext: () => void;
	onPrevious: () => void;
};

const eventManager = new Map<string, EventObj>();

export const navigationEventManager = {
	register: (page, eventsObject: EventObj) => {
		eventManager.set(page, eventsObject);
	},
	unregister: page => {
		return eventManager.delete(page);
	},
	getEventObj(page) {
		return eventManager.get(page);
	},
	getEventManager: () => {
		return eventManager;
	},
};
